import WingBlank from 'antd-mobile/lib/wing-blank';
export default WingBlank;



// WEBPACK FOOTER //
// ./components/wing-blank/index.tsx